import React, { useState, useEffect, forwardRef } from "react";
import CategoryProductList from "../../components/categorysection/CategoryProductList";
import { fetchCategory } from "../../../domain/usecases/fetchCategoryProduct"; // Import the fetch function
import SpinnerLoading from "../../components/spinnerLoading/SpinnerLoading";
import { CategoryProduct } from "../../../domain/entities/CategoryProduct";

const CategoryProductSection = forwardRef<HTMLDivElement>((props, ref) => {
    const [categories, setCategories] = useState<CategoryProduct[]>([]);
    const [loading, setLoading] = useState(true); // State for loading
    const [error, setError] = useState<string | null>(null); // State for errors

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const categoriesData = await fetchCategory(); // Fetch category products
                setCategories(categoriesData); // Set categories in state
            } catch (err) {
                console.error("Failed to fetch category product:", err);
                setError("Failed to load category product. Please try again later.");
            } finally {
                setLoading(false); // End loading
            }
        };

        setTimeout(() => setLoading(false), 2000);
        fetchCategories();
    }, []); // Runs only once on component mount

    if (loading) {
        return <SpinnerLoading />;
    }

    if (error) {
        return <div>{error}</div>;
    }

    return (
        <div ref={ref}>
            <CategoryProductList categories={categories} />
        </div>
    );
});

export default CategoryProductSection;
